<template>
    <InputNumber 
        :max="attrs.max||Infinity" 
        :min="attrs.min||-Infinity" 
        :value="bindValue" 
        @input="onInput" 
        :placeholder="attrs.placeholder || '请输入数字'" style="width: 100%;"></InputNumber>
</template>
<script>
    /**
     * 数字输入组件
     */
    export default {
        name: 'LyInputNumber',
        props: {
            value: {
                type: [Number, String],
                default: 0
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            },
            page: {
                type: Object,
                default:_ => new Object()
            },
        },
        watch: {
            value: {
                handler () {
                    this.initBindValue()
                },
                immediate: true
            }
        },
        data () {
            return {
                isBind: true,
                bindValue: 0,
                isLoading: false,
                watchFieldVaue: {}
            }
        },
        created () {
            this.initWatchField()  
        },
        methods: {
            /**
             * 初始化监听字段
             */
            initWatchField () {
                if (this.attrs.watchField) {
                    let watchArr = this.attrs.watchField.split('|')
                    for (let i = 0, len = watchArr.length; i < len; i++) {
                        let field = watchArr[i]
                        if (this.page.hasOwnProperty(field)) {
                            this.watchFieldVaue[field] = this.page[field]
                            this.doWatch(this.page, field, 'page.' + field)
                        } else if (this.row.hasOwnProperty(field)){
                            this.watchFieldVaue[field] = this.row[field] // 初始化获取值，在input没出现时，就有值的情况
                            this.doWatch(this.row, field, 'row.' + field)
                        }   
                    }
                }
            },
            /**
             * 字段的监听
             */
            doWatch (obj, field, watchField) {
                this.$watch(watchField, function (val) {
                    this.timer && clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        let fieldValue =  obj[field]
                        if (fieldValue) {
                            this.watchFieldVaue[field] = fieldValue
                            this.queryValue()
                        }
                    }, 500)
                }, {
                    deep:true
                })
            },
            initBindValue () {
                if (this.bindValue != this.value && this.isBind) {
                    this.bindValue = this.attrs.isInt ? parseInt(this.value) : parseFloat(this.value)
                } else {
                    this.isBind = true
                }
            },
            onInput (val) {
               if (val == null) {
                   val = 0
                   this.isBind = false
               }
               if (this.attrs.isInt) {
                   val = parseInt(val)
                   this.bindValue = val
               }
                this.$emit('input', val)
            },
            /**
             * 根据监听字段获取值
             */
            queryValue () {
                this.isLoading = true
                this.$api.query(this.attrs.api, this.watchFieldVaue).then(rs => {
                    this.isLoading = false
                    // 2020-11-26 wxq 避免多个监听同一对象而引起的重复请求
                    let bindArr = this.attrs.bindField.split('|')
                    if(bindArr && bindArr.length > 0){
                        bindArr.map((item)=>{
                            if (rs && rs.hasOwnProperty(item)) {
                                this.$set(this.page,item,String(rs[item]))
                             }
                        })
                    }else{
                        if (rs && rs.hasOwnProperty(this.attrs.field)) {
                            this.onInput(String(rs[this.attrs.field]))
                        }
                    }
                }).catch((err) => {
                    this.$Message['error']({
                        background: true,
                        content: err
                    })
                    this.isLoading = false
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/input-number/src/index.vue